<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.set_money_pwd') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-intro">
          <div class="km-intro__ico">🔐</div>
          <div class="km-intro__body">
            <h3>Set your payment PIN</h3>
            <p>Choose a 4-digit code. You'll enter it to confirm transactions.</p>
          </div>
        </div>

        <div class="km-card kp-pw">
          <div class="kp-pw__group">
            <div class="kp-pw__title">{{ $t('setting.money_place') }}</div>
            <van-password-input
              :value="opw" :length="4" :gutter="10" :focused="oshowKeyboard"
              @focus="oshowKeyboard = true; tshowKeyboard = false;"
            />
          </div>
          <div class="kp-pw__divider"></div>
          <div class="kp-pw__group">
            <div class="kp-pw__title">{{ $t('setting.money_again_place') }}</div>
            <van-password-input
              :value="tpw" :length="4" :gutter="10" :focused="tshowKeyboard"
              @focus="tshowKeyboard = true; oshowKeyboard = false;"
            />
          </div>
        </div>

        <div style="padding: 16px 4px 0;">
          <button class="km-btn" @click="setPayPassword()">{{ $t('reservation.submit') }}</button>
        </div>
      </section>
    </main>

    <van-number-keyboard
      v-model="opw" :show="oshowKeyboard"
      @input="opw.length !== 3 ? oshowKeyboard = true : tshowKeyboard = true"
      @blur="oshowKeyboard = false"
    />
    <van-number-keyboard
      v-model="tpw" :show="tshowKeyboard"
      @input="tpw.length !== 3 ? tshowKeyboard = true : (tshowKeyboard = false, oshowKeyboard = false)"
      @blur="tshowKeyboard = false"
    />
  </div>
</template>

<script>
export default {
  data() { return { opw: '', tpw: '', oshowKeyboard: true, tshowKeyboard: false, userInfo: {} }; },
  methods: {
    back() { return window.history.back(); },
    setPayPassword() {
      this.oshowKeyboard = false; this.tshowKeyboard = false;
      if (this.opw.length !== 4) { this.oshowKeyboard = true; this.$toast(this.$t("setting.prefect")); return false; }
      if (this.tpw.length !== 4) { this.tshowKeyboard = true; this.$toast(this.$t("setting.prefect")); return false; }
      if (this.opw !== this.tpw) { this.$toast(this.$t("setting.prefect")); return false; }
      this.$http({ method: 'post', data: { paypassword: this.opw }, url: 'user_set_paypw' }).then(res => {
        if (res.code === 200) {
          setTimeout(() => { this.$toast(res.msg); }, 500);
          this.$router.push("Mine");
        } else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) { this.userInfo = res.data; this.radio = res.data.sex; }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.km-intro {
  display: flex; gap: 12px; align-items: flex-start;
  padding: 14px 16px; border-radius: 16px;
  background: linear-gradient(135deg, rgba(251,191,36,.1), rgba(245,158,11,.1));
  border: 1px solid rgba(251,191,36,.25);
  margin-bottom: 14px;
}
.km-intro__ico {
  width: 36px; height: 36px; border-radius: 10px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(245,158,11,.3);
}
.km-intro__body h3 { margin: 0 0 2px; font-size: 14px; font-weight: 800; color: #2a1a3f; }
.km-intro__body p { margin: 0; font-size: 12px; color: #5a4a78; line-height: 1.5; }

.kp-pw { padding: 20px 18px; }
.kp-pw__group { padding: 6px 0; }
.kp-pw__title {
  font-size: 12px; font-weight: 700; color: #8273a0;
  text-transform: uppercase; letter-spacing: .06em;
  margin-bottom: 14px;
}
.kp-pw__divider {
  height: 1px; background: rgba(255,77,141,.12); margin: 14px 0;
}
::v-deep .van-password-input__security {
  margin: 0 auto;
}
::v-deep .van-password-input__item {
  background: #fff9fb !important;
  border: 1.5px solid rgba(255,77,141,.15) !important;
  border-radius: 10px !important;
  font-size: 22px; font-weight: 800; color: #2a1a3f;
  height: 50px;
}
::v-deep .van-password-input__item.van-password-input__item--focus {
  border-color: #ff4d8d !important;
  box-shadow: 0 0 0 3px rgba(255,77,141,.12);
}
</style>
